// extracted by mini-css-extract-plugin
module.exports = {"separator":"_1WnBb","postExcerpt":"_2o0y0","postTitle":"aOiZx"};